import React, { useCallback } from 'react';

import { NotificationManager } from '@atlas/core';
import { Button, ConfirmationPopup } from '@atlas/ui';

import ModalPortal from 'common/ModalPortal/ModalPortal';

const Popup = props => {
  const {
    children,
    data = {},
    id,
    isDisabledCloseButton,
    isDisabledConfirmButton,
    isLoadingCloseButton,
    isLoadingConfirmButton,
    message,
    title,
  } = props;
  const { className, closeLabel = 'no', confirmLabel = 'confirm', secondaryBtn = true } = data;

  const onCloseHandler = useCallback(() => {
    if (typeof data.onClose === 'function') {
      data.onClose();
    }

    NotificationManager.removeNotification(id);
  }, [data, id]);

  const onConfirmHandler = useCallback(() => {
    if (typeof data.onConfirm === 'function') {
      data.onConfirm();
    }

    NotificationManager.removeNotification(id);
  }, [data, id]);

  return (
    <ModalPortal backdropOff className="confirm-popup-z-index">
      <ConfirmationPopup className={className} text={message} title={title}>
        {children && <div className="popup__content">{children}</div>}
        <div className="popup__buttons">
          {secondaryBtn && (
            <Button
              className="secondary block big"
              disabled={isDisabledCloseButton}
              label={closeLabel}
              loading={isLoadingCloseButton}
              onClick={onCloseHandler}
            />
          )}
          <Button
            className="primary block big"
            disabled={isDisabledConfirmButton}
            label={confirmLabel}
            loading={isLoadingConfirmButton}
            onClick={onConfirmHandler}
          />
        </div>
      </ConfirmationPopup>
    </ModalPortal>
  );
};

export default Popup;
